import { render, staticRenderFns } from "./photo-upload.vue?vue&type=template&id=1f46b33a&scoped=true&"
import script from "./photo-upload.vue?vue&type=script&lang=js&"
export * from "./photo-upload.vue?vue&type=script&lang=js&"
import style0 from "./photo-upload.vue?vue&type=style&index=0&id=1f46b33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f46b33a",
  null
  
)

export default component.exports